module.exports = __webpack_public_path__ + "static/media/lp-steps-3.3cefe749.jpg";